import { usePostHog } from 'posthog-js/react'
import { useSearchParams } from 'next/navigation'
import { SalaryFilterParam } from '../constants'
import { getSalaryDetails } from '../common/salary-details-utils'
import { SalaryType } from '@/lib/generated/graphql-types'

type ShareType = 'page' | 'pane'

export function useShareTracking() {
  const posthog = usePostHog()
  const searchParams = useSearchParams()

  const trackShare = (
    type: ShareType,
    salaryId?: string,
    salary?: SalaryType,
  ) => {
    const eventName =
      type === 'page' ? 'shared_salary_page' : 'shared_salary_pane'

    // use provided salaryId or get from URL
    const targetSalaryId =
      salaryId || searchParams.get(SalaryFilterParam.salaryId) || ''

    // get profession, specialty, and location names from salary details object
    let professionName = ''
    let specialtyName = ''
    let locationName = ''
    if (salary) {
      const salaryDetails = getSalaryDetails(salary)
      professionName = salaryDetails.professionTitle
      specialtyName = salaryDetails.specialtyTitle
      locationName = salaryDetails.location
    }

    posthog.capture(eventName, {
      screen_name: 'salary_results',
      product_area: 'salaries',
      module_name: type === 'page' ? 'main' : 'pane',
      profession_name: professionName,
      specialty_name: specialtyName,
      location_name: locationName,
      salary_id: targetSalaryId,
    })
  }

  return { trackShare }
}
